export const jsonToBlob = (json) => {
    const jsonString = JSON.stringify(json);
    return new Blob([jsonString], {
        type: 'application/json'
    });
}